let storyList = $('.has-popup')
let storyPopup = $('.brand-story-popup')
let closeArea = $('.brand-story-popup .pop-bg')
let closeBtn = $('.brand-story-popup .close-btn')

storyList.on('click', function(){
    $('.brand-story-popup .popup-content figure img').attr('src', $(this).find('img').attr('src'))

    $('.brand-story-popup .popup-content figure figcaption').html(`<span class="h2">${$(this).find('figcaption span').text()}</span><p>${$(this).find('figcaption p').text()}</p>`)

    $('.brand-story-popup .popup-content>p').text($(this).find('figure').attr('data-intro'))

    storyPopup.addClass('show')
})

closeArea.on('click', function(){
    storyPopup.removeClass('show')
})

closeBtn.on('click', function(){
    storyPopup.removeClass('show')
})

window.addEventListener('load', function(){
    const slider = document.querySelector('.brand-story-content .brand-story-wrapper ul');
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('active');
    });
    slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('active');
    });
    slider.addEventListener('mousemove', (e) => {
    if(!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 3; //scroll-fast
    slider.scrollLeft = scrollLeft - walk;
    });
})